import { TakeActionDropdownData } from 'components/TakeActionDropdown/types/TakeActionDropdownData';
import { searchGetEventsRoutePath } from 'modules/search/routing/helpers/searchGetEventsRoutePath';
import { searchGetVolopsRoutePath } from 'modules/search/routing/helpers/searchGetVolopsRoutePath';

export const takeActionDropdownDataPt: TakeActionDropdownData = {
  search: {
    title: 'Busca',
    items: [
      {
        type: 'volop',
        title: 'Voluntariado',
        href: searchGetVolopsRoutePath({ lang: 'pt' }),
      },
      {
        type: 'event',
        title: 'Eventos',
        href: searchGetEventsRoutePath({ lang: 'pt' }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'idealist-movement',
        title: 'Movimento Idealista',
        description:
          'Bem Vindo ao Movimento Idealista. Aqui você encontra formas de se conectar e pode conhecer o ecossistema idealista para transformação social.',
        href: '/pt/movimento',
      },
      {
        type: 'recipes-for-action',
        title: 'Receitas para Ação',
        description: 'Boas ideias para fazer do mundo um lugar melhor.',
        href: 'pt/receitas?pq=',
      },
      {
        type: 'blog',
        title: 'Blog',
        description:
          'Artigos sobre dicas de carreira, voluntariado, captação de recursos, recrutamento e ativismo social.',
        href: 'pt/blog',
      },
    ],
  },
};
